import Dexie, { Table } from "dexie";

// Define the type of data stored
export interface ApiResponse {
  url: string;      // Primary key
  data: any;        // Can be JSON from API
  timestamp: number; // For cache expiry (optional)
}

// Extend Dexie
export class MyAppDB extends Dexie {
  // Tell TS that "responses" is a table of ApiResponse
  responses!: Table<ApiResponse, string>;

  constructor() {
    super("MyAppDB");

    this.version(1).stores({
      responses: "url" // 'url' is the primary key
    });
  }
}

// Export single instance
export const db = new MyAppDB();
